/* eslint-disable max-lines */
// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import dynamic from 'next/dynamic';
import { withRouter } from 'next/router';
import isEqual from 'lodash/isEqual';
import Constants from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.constants';
import PriceCurrency from '@tcp/core/src/components/common/molecules/PriceCurrency';
import Notification from '@tcp/core/src/components/common/molecules/Notification';
import { isMobileWeb } from '@tcp/core/src/utils/utils.web';
import PlaceCashBanner from '@tcp/core/src/components/features/CnC/PlaceCashBanner';
import { isTier1Device } from '@tcp/web/src/utils/device-tiering';
import Recommendations from '@tcp/core/src/components/common/molecules/Recommendations';
import ErrorMessage from '@tcp/core/src/components/features/CnC/common/molecules/ErrorMessage';
import pushEventToAdobeAnalytics from '@tcp/core/src/adobeAnalytics/adobe.utils';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  bagTileCSS,
  customStyles,
} from '@tcp/core/src/components/features/CnC/common/molecules/InformationHeader/styles/InformationHeader.style';
import withRefWrapper from '../../../../common/hoc/withRefWrapper';
import withHotfix from '../../../../common/hoc/withHotfix';

import ProductTileWrapper from '../../CartItemTile/organisms/ProductTileWrapper/container/ProductTileWrapper.container';
import withStyles from '../../../../common/hoc/withStyles';
import Row from '../../../../common/atoms/Row';
import Col from '../../../../common/atoms/Col';
import BodyCopy from '../../../../common/atoms/BodyCopy';
import AddedToBagActions from '../../AddedToBagActions';
import CnCTemplate from '../../common/organism/CnCTemplate';
import BAGPAGE_CONSTANTS from '../BagPage.constants';
import styles, {
  addedToBagActionsStyles,
  recommendationStyles,
  recommendationStylesPdp,
} from '../styles/BagPage.style';
import BagPageUtils from './Bagpage.utils';
import InformationHeader from '../../common/molecules/InformationHeader';
import {
  isClient,
  getViewportInfo,
  isCanada,
  getAPIConfig,
  markRUMTimings,
} from '../../../../../utils';
import BagPageVMPView from './BagPageVMP.view';
import BuyItAgainBagPageContainer from '../../BuyItAgainBagPage/container/BuyItAgainBagPage.container';
import BossUnavailableGroup from '../../CartItemTile/molecules/BossUnavailableTile';
import CARTPAGE_CONSTANTS from '../../CartItemTile/CartItemTile.constants';
import BAGPAGE_LABELS from '../container/Bagpage.labels';
import OutfitCarousel from '../molecules/OutfitCarousel.view';
import SocialProofBanner from '../../common/organism/SocialProofBanner';
import SimplifiedHeader from '../../common/molecules/SimplifiedHeader/views/SimplifiedHeader.view';
import CollapsableError from '../../common/molecules/CollapsableError';
import GlobalErrorComponentContainer from '../../../../common/molecules/GlobalErrorComponent/container/GlobalErrorComponent.container';
import CouponDetailModal from '../../common/organism/CouponAndPromos/views/CouponDetailModal.view';

// SYTE Vendor Script
const SyteVendorScript = dynamic(() => import('@tcp/web/src/components/common/vendors/Syte/Syte'));

const PLCCTopOfBagView = dynamic(() =>
  // eslint-disable-next-line extra-rules/no-commented-out-code
  import(/* webpackChunkName: "plcc-banner-cnc" */ './PLCCTopOfBag.view')
);

const STICKY_HEADER_HEIGHT = 66;
const CHECKOUT_BAGPAGE_LABEL = 'checkout.bagPage';
class BagPageView extends React.Component {
  static shareIcon = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
        className="cart-share-icon"
      >
        <path
          d="M10.6564 6.56549H14.2462C14.5868 6.56549 14.8633 6.83913 14.8633 7.17766V16.3878C14.8633 16.7263 14.5868 17 14.2462 17H1.45711C1.1159 17 0.840088 16.7263 0.840088 16.3878V7.17766C0.840088 6.83913 1.11528 6.56549 1.45588 6.56549C2.06859 6.56549 3.18973 6.56549 5.04698 6.56549"
          stroke="#1A1A1A"
          strokeLinecap="round"
        />
        <path d="M7.85136 11.7824V1.3479" stroke="#1A1A1A" strokeLinecap="round" />
        <path
          d="M5.04688 3.78232L7.85126 1L10.6556 3.78232"
          stroke="#1A1A1A"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  constructor(props) {
    super(props);
    this.state = BagPageUtils.getDefaultStateValues();
    this.bagPageHeader = null;
    this.bagActionsContainer = null;
    this.bagCondensedHeader = null;
    this.timer = null;
    this.bagPageCondenseHeaderBind = false;
    this.bagPageAnchoring = false;
    this.getBagPageHeaderRef = this.getBagPageHeaderRef.bind(this);
    this.getBagActionsContainerRef = this.getBagActionsContainerRef.bind(this);
    this.getBagCondensedHeader = this.getBagCondensedHeader.bind(this);
    this.pageScrollEventUnbind = null;
    this.isUpdateShippingCalled = false;
    this.bagPageStaticLabels = getLabelFromCopyOrFromTranslation(
      CHECKOUT_BAGPAGE_LABEL,
      BAGPAGE_LABELS
    );
    this.bagPageDynamicLabels = getDynamicLabelValues('dynamic.cart');
    this.hasFiredPriceDropAnalytics = false;
  }

  componentDidMount() {
    if (isClient()) {
      window.addEventListener('beforeunload', BagPageUtils.onPageUnload);
    }
    const {
      setVenmoPaymentInProgress,
      setApplePaymentInProgress,
      isHideStickyCheckoutButton,
      toggleSPC,
      firstItemInfo,
      updateStoreItem,
      orderType,
      isInternationalShipping,
      isEnableShipmentTilesForInternationalSite,
    } = this.props;

    const isBossOrBopis = orderType === 'PURE_BOPIS' || orderType === 'PURE_BOSS';

    setVenmoPaymentInProgress(false);
    setApplePaymentInProgress(false);

    this.setState({ hasMounted: true });
    this.setState({
      orderLedgerAfterView: this.renderActions(),
    });
    if (isHideStickyCheckoutButton) {
      window.addEventListener('scroll', this.onScroll);
    }
    markRUMTimings();
    toggleSPC({ isSPC: false });
    if (isInternationalShipping && isBossOrBopis && isEnableShipmentTilesForInternationalSite) {
      const payload = {
        ...firstItemInfo,
        c_orderItemType: 'ECOM',
        toggle: 'ECOM',
        isScrollToTile: true,
      };
      updateStoreItem(payload);
      this.setState({ hasUpdateStoreApiCalled: false });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const isStateSame = isEqual(nextState, this.state);
    const isPropSame = isEqual(nextProps, this.props);
    return !(isStateSame && isPropSame);
  }

  handleInternationalShipping() {
    const {
      isInternationalShipping,
      orderType,
      isEnableShipmentTilesForInternationalSite,
      updateStoreItem,
      firstItemInfo,
    } = this.props;
    const { hasUpdateStoreApiCalled } = this.state;

    const isBossOrBopis = orderType === 'PURE_BOPIS' || orderType === 'PURE_BOSS';

    if (
      isInternationalShipping &&
      isBossOrBopis &&
      isEnableShipmentTilesForInternationalSite &&
      hasUpdateStoreApiCalled
    ) {
      const payload = {
        ...firstItemInfo,
        c_orderItemType: 'ECOM',
        toggle: 'ECOM',
        isScrollToTile: true,
      };
      updateStoreItem(payload);
      this.setState({ hasUpdateStoreApiCalled: false });
    }
  }

  setupScrollListener() {
    const { isMobile } = this.props;
    if (!this.bagPageCondenseHeaderBind) {
      const checkoutCta = this.bagActionsContainer;
      if (checkoutCta && !isMobile) {
        this.addScrollListener();
        this.bagPageCondenseHeaderBind = true;
      }
    }
  }

  handleMobileAnchoring() {
    const { isMobile, bagLoading, isDisableBagAnchoring } = this.props;
    if (isMobile && !this.bagPageAnchoring && !bagLoading && !isDisableBagAnchoring) {
      const timer = window.setTimeout(() => {
        const cartPageTitleHeader = document.querySelector('.cartPageTitleHeader');
        if (cartPageTitleHeader) {
          window.scrollTo({
            top: cartPageTitleHeader.offsetTop - STICKY_HEADER_HEIGHT,
            behavior: 'smooth',
          });
          clearTimeout(timer);
        }
      }, 100);
      this.bagPageAnchoring = true;
    }
  }

  toggleStickyCheckoutButton(prevProps) {
    const { isHideStickyCheckoutButton } = this.props;
    const { isHideStickyCheckoutButton: prevIsHideStickyCheckoutButton } = prevProps;

    if (
      isHideStickyCheckoutButton &&
      prevIsHideStickyCheckoutButton !== isHideStickyCheckoutButton
    ) {
      window.removeEventListener('scroll', this.onScroll);
      window.addEventListener('scroll', this.onScroll);
    }
  }

  handleBackPackDeletedError(prevProps) {
    const { showBackPackDeletedError, setBackPackDeletedErrorAction } = this.props;
    const { showBackPackDeletedError: prevShowBackPackDeletedError } = prevProps;

    if (prevShowBackPackDeletedError !== showBackPackDeletedError && showBackPackDeletedError) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        setBackPackDeletedErrorAction(false);
      }, 10000);
    }
  }

  handleShareCartError(prevProps) {
    const { shareCartError, saveShareCartErrActn } = this.props;
    const { shareCartError: prevShareCartError } = prevProps;

    const shareCartErrorMessage = shareCartError?.errorMessage;
    if (prevShareCartError?.errorMessage !== shareCartErrorMessage && shareCartErrorMessage) {
      clearTimeout(this.shareCartTimeout);
      this.shareCartTimeout = setTimeout(() => {
        saveShareCartErrActn(null);
      }, 5000);
    }
  }

  handlePriceDropNotification() {
    const {
      cartOrderItems,
      sflItems,
      isPriceDropNotificationApiEnabled,
      triggerPriceDropNotificationAction,
      hasSflCallCompleted,
    } = this.props;

    const { hasTriggeredPriceDropNotification } = this.state;
    const cartProducts = cartOrderItems ? JSON.parse(JSON.stringify(cartOrderItems)) : [];
    const sflProducts = sflItems ? JSON.parse(JSON.stringify(sflItems)) : [];

    const cartHasPriceChange = BagPageUtils.hasPriceChanged(cartProducts);
    const sflHasPriceChange = BagPageUtils.hasPriceChanged(sflProducts);

    if (
      (cartHasPriceChange || sflHasPriceChange) &&
      isPriceDropNotificationApiEnabled &&
      !hasTriggeredPriceDropNotification &&
      hasSflCallCompleted
    ) {
      const payload = {
        basketItems: cartHasPriceChange,
        saveForLater: sflHasPriceChange,
      };
      triggerPriceDropNotificationAction(payload);
      this.setState({ hasTriggeredPriceDropNotification: true });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    this.handlePriceDropNotification(prevState);
    this.handleInternationalShipping();
    this.setupScrollListener();
    this.handleMobileAnchoring();
    this.toggleStickyCheckoutButton(prevProps);
    this.handleBackPackDeletedError(prevProps);
    this.handleShareCartError(prevProps);
  }

  componentWillUnmount() {
    const {
      isHideStickyCheckoutButton,
      setBackPackDeletedErrorAction,
      updatePriceDropItemValuesAction,
      isPriceDropNotificationEnabled,
      cartOrderItems,
      sflItems,
      priceDropHolidayDateList,
      priceDropPercentageValue,
      updatePriceDropItemValuesInSflAction,
      getCartDataAction,
    } = this.props;
    if (isClient()) {
      window.removeEventListener('scroll', this.scrollEventLister);
      window.removeEventListener('beforeunload', BagPageUtils.onPageUnload);
      if (typeof this.pageScrollEventUnbind === 'function') this.pageScrollEventUnbind();
    }
    if (isHideStickyCheckoutButton) {
      window.removeEventListener('scroll', this.onScroll);
    }
    setBackPackDeletedErrorAction(false);
    if (isPriceDropNotificationEnabled) {
      const cartProducts = cartOrderItems ? JSON.parse(JSON.stringify(cartOrderItems)) : [];
      const sflProducts = sflItems ? JSON.parse(JSON.stringify(sflItems)) : [];

      const cartProductsWithFlag = BagPageUtils.getProductsWithPriceDropFlag(
        cartProducts,
        'cart',
        priceDropHolidayDateList,
        priceDropPercentageValue
      );
      const sflProductsWithFlag = BagPageUtils.getProductsWithPriceDropFlag(
        sflProducts,
        'sfl',
        priceDropHolidayDateList,
        priceDropPercentageValue
      );

      const cartProductsWithPriceDrop = cartProductsWithFlag.filter(
        (product) => product?.hasPriceDrop
      );
      const sflProductsWithPriceDrop = sflProductsWithFlag.filter(
        (product) => product?.hasPriceDrop
      );

      if (cartProductsWithPriceDrop?.length > 0 && sflProductsWithPriceDrop?.length > 0) {
        const cartPayload = BagPageUtils.generatePriceDropPayload(cartProductsWithPriceDrop);
        updatePriceDropItemValuesAction(cartPayload);
        const sflPayload = BagPageUtils.generatePriceDropPayload(sflProductsWithPriceDrop);
        updatePriceDropItemValuesInSflAction(sflPayload);
        getCartDataAction({ skipCache: true });
      } else if (cartProductsWithPriceDrop?.length > 0) {
        const cartPayload = BagPageUtils.generatePriceDropPayload(cartProductsWithPriceDrop);
        updatePriceDropItemValuesAction(cartPayload);
        getCartDataAction({ skipCache: true });
      } else if (sflProductsWithPriceDrop?.length > 0) {
        const sflPayload = BagPageUtils.generatePriceDropPayload(sflProductsWithPriceDrop);
        updatePriceDropItemValuesInSflAction(sflPayload);
      }
    }
  }

  onScroll = () => {
    const { isScrolling } = this.state;
    const { isStickyCheckoutButtonEnabled } = this.props;
    if (document.body.getBoundingClientRect().top < 12 && !isStickyCheckoutButtonEnabled) {
      this.setState((prev) => ({
        ...prev,
        isScrolling: document.body.getBoundingClientRect().top < prev.scrollPos,
        scrollPos: document.body.getBoundingClientRect().top,
      }));
    }
    if (isScrolling) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.setState({ isScrolling: false });
      }, 200);
    }
  };

  setHeaderErrorState = (state, ...params) => {
    this.setState({ headerError: true, params });
  };

  getBagPageHeaderRef(ref) {
    this.bagPageHeader = ref;
  }

  getIsUpdateShippingCalled = () => {
    return this.isUpdateShippingCalled;
  };

  setIsUpdateShippingCalled = () => {
    this.isUpdateShippingCalled = true;
  };

  getBagActionsContainerRef(ref) {
    this.bagActionsContainer = ref;
  }

  getBagCondensedHeader(ref) {
    this.bagCondensedHeader = ref;
  }

  addScrollListener = () => {
    const checkoutCtaStickyPos = BagPageUtils.getElementStickyPosition(this.bagActionsContainer);
    this.scrollEventLister = this.handleBagHeaderScroll.bind(this, checkoutCtaStickyPos);
    this.pageScrollEventUnbind = BagPageUtils.bindScrollEvent(this.scrollEventLister);
  };

  getPlaceCashRecommendationProductLength = (products) => {
    const { showPlaceCashRecommendation } = this.state;
    if (!showPlaceCashRecommendation && products && products.length > 0) {
      this.setState({ showPlaceCashRecommendation: true });
    } else if (showPlaceCashRecommendation && products && products.length < 1) {
      this.setState({ showPlaceCashRecommendation: false });
    }
  };

  getPlaceRewardRecommendationProductLength = (products) => {
    const { showPlaceRewardRecommendation } = this.state;
    if (!showPlaceRewardRecommendation && products && products.length > 0) {
      this.setState({ showPlaceRewardRecommendation: true });
    } else if (showPlaceRewardRecommendation && products && products.length < 1) {
      this.setState({ showPlaceRewardRecommendation: false });
    }
  };

  shouldUpdateCondensedHeaderTopOldHeader = ({
    isHeaderScrollViewDisabled,
    isHeaderStickyClassPresent,
    isGlobalHeaderRedesignEnabled,
    isGlobalDefaultHeaderRedesignEnabled,
  }) => {
    return (
      !isHeaderScrollViewDisabled &&
      isHeaderStickyClassPresent &&
      this.bagCondensedHeader &&
      !isGlobalHeaderRedesignEnabled &&
      !isGlobalDefaultHeaderRedesignEnabled
    );
  };

  getCondensedHeaderTopValue = ({
    isGlobalHeaderRedesignEnabled,
    headerMiddleNavHeight,
    isGlobalDefaultHeaderRedesignEnabled,
    stickyHeaderHeight,
    condensedPageHeaderHeight,
  }) => {
    if (isGlobalHeaderRedesignEnabled) {
      return `${headerMiddleNavHeight}px`;
    }
    if (isGlobalDefaultHeaderRedesignEnabled) {
      return `${stickyHeaderHeight}px`;
    }
    return `${condensedPageHeaderHeight.toString()}px`;
  };

  handleBagHeaderScroll = (sticky) => {
    const {
      isHeaderScrollViewDisabled,
      isHeaderStickyClassPresent,
      stickyHeaderHeight,
      isGlobalHeaderRedesignEnabled,
      headerMiddleNavHeight,
      isGlobalDefaultHeaderRedesignEnabled,
    } = this.props;
    const condensedPageHeaderHeight = BagPageUtils.getPageLevelHeaderHeight();
    if (isClient() && window.pageYOffset > sticky + 30) {
      if (
        this.shouldUpdateCondensedHeaderTopOldHeader({
          isHeaderScrollViewDisabled,
          isHeaderStickyClassPresent,
          isGlobalHeaderRedesignEnabled,
          isGlobalDefaultHeaderRedesignEnabled,
        })
      ) {
        this.bagCondensedHeader.firstElementChild.style.top = `${stickyHeaderHeight}px`;
      } else {
        this.setState({ showCondensedHeader: true, loadPaypalStickyHeader: true }, () => {
          this.bagCondensedHeader.firstElementChild.style.top = this.getCondensedHeaderTopValue({
            isGlobalHeaderRedesignEnabled,
            headerMiddleNavHeight,
            isGlobalDefaultHeaderRedesignEnabled,
            stickyHeaderHeight,
            condensedPageHeaderHeight,
          });
        });
      }
    } else {
      this.setState({ showCondensedHeader: false });
    }
  };

  wrapSection = (Component, orderItemsCount) => {
    const isNoNEmptyBag = orderItemsCount > 0;
    const colSizes = { small: 6, medium: 5, large: 8 };
    if (!isNoNEmptyBag) {
      return <Col colSize={colSizes}>{Component}</Col>;
    }
    return Component;
  };

  renderBIA = () => {
    return (
      <BuyItAgainBagPageContainer
        {...this.props}
        page={Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG}
        renderRecommendations={this.renderRecommendations}
        renderBagPageOutfits={this.renderBagPageOutfits}
      />
    );
  };

  renderBagPageOutfits = () => {
    const { excludedIds, bagOutfitProducts } = this.props;
    return <OutfitCarousel excludedIds={excludedIds} bagOutfitProducts={bagOutfitProducts} />;
  };

  renderRecommendations = (data, payload) => {
    const { fromBIA } = payload || {};
    this.willAlsoViewedCarouselDisplay = isTier1Device();
    const {
      sflItems,
      orderItemsCount,
      excludedIds,
      productId,
      isNewBag,
      spcBag,
      isBIACombinedCarouselEnabled,
      isOutfitsOnBagEnabled,
    } = this.props;
    const hideRec = orderItemsCount === 0 && sflItems.size > 0;
    const isNoNEmptyBag = orderItemsCount > 0;
    const headerText = isNoNEmptyBag
      ? this.bagPageDynamicLabels.lbl_you_may_also_like_full_bag_page
      : this.bagPageDynamicLabels.lbl_you_may_also_like_empty_bag_page;
    let carouselOptions;
    if (isNoNEmptyBag) {
      carouselOptions = BagPageUtils.CarouselOptions.CAROUSEL_OPTIONS;
    }
    let customProductsLength = 3;
    if (isClient() && getViewportInfo()?.isDesktop) {
      customProductsLength = 6;
    }
    return (
      <>
        {(fromBIA || !(isBIACombinedCarouselEnabled || isOutfitsOnBagEnabled)) && (
          <div>
            {!hideRec && productId ? (
              <div className="may-like-recommendation overwrite-recommendation-css">
                <Recommendations
                  customProductsLength={customProductsLength}
                  page={Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG}
                  headerLabel={headerText}
                  variations="moduleO"
                  inheritedStyles={recommendationStyles}
                  carouselConfigProps={carouselOptions}
                  excludedIds={excludedIds}
                  partNumber={productId}
                  starRatingSize={{ small: 68, large: 68 }}
                  sequence="1"
                  showPeek={{ small: true, medium: false }}
                  spcBag={spcBag}
                  newBag={isNewBag}
                  bagItemCount={orderItemsCount}
                  isBagPage
                  fromBIACarousel={fromBIA}
                  recommendationCarouselRedesign
                  isBIACombinedCarouselEnabled={isBIACombinedCarouselEnabled}
                  fromBIA={fromBIA}
                />
              </div>
            ) : (
              <div className="may-like-recommendation overwrite-recommendation-css">
                <Recommendations
                  customProductsLength={customProductsLength}
                  page={Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG}
                  headerLabel={headerText}
                  variations="moduleO"
                  inheritedStyles={recommendationStyles}
                  starRatingSize={{ small: 68, large: 68 }}
                  carouselConfigProps={carouselOptions}
                  sequence="1"
                  showPeek={{ small: true, medium: false }}
                  newBag={isNewBag}
                  spcBag={spcBag}
                  bagItemCount={orderItemsCount}
                  isBagPage
                  fromBIACarousel={fromBIA}
                  recommendationCarouselRedesign
                  isBIACombinedCarouselEnabled={isBIACombinedCarouselEnabled}
                  fromBIA={fromBIA}
                />
              </div>
            )}
          </div>
        )}
        {this.willAlsoViewedCarouselDisplay && !fromBIA && this.renderRecommendationsForRecent()}
      </>
    );
  };

  renderPlaceCashRecommendations = () => {
    const { isNewBag, spcBag } = this.props;
    const { showPlaceCashRecommendation, orderItemsCount } = this.state;

    const recommendationAttributes = {
      variations: 'moduleO',
      page: Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG,
      showLoyaltyPromotionMessage: false,
      headerAlignment: 'center',
      accordionHeader: true,
      showHeightToggle: true,
    };
    const carouselOptions = BagPageUtils.PlacecashCarouselOptions.CAROUSEL_OPTIONS;

    const hideContent = showPlaceCashRecommendation ? '' : 'hide-content';
    let customProductsLength = 3;
    if (getViewportInfo().isDesktop) {
      customProductsLength = 2;
    }

    return (
      <>
        <div className={`cart-placecash ${hideContent}`}>
          <div className="cart-placecash-button">
            {showPlaceCashRecommendation && <PlaceCashBanner isLeftProgressBar />}
          </div>
          <div className="cart-placecash-product">
            <Recommendations
              customProductsLength={customProductsLength}
              headerLabel={getDynamicLabelValues('dynamic.cart.lbl_add_product_toget_placereward')}
              portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.ADD_PRODUCT_TO_GET_PLACECASH}
              sequence="0"
              starRatingSize={{ small: 63, large: 60 }}
              getRecommendationProducts={this.getPlaceCashRecommendationProductLength}
              inheritedStyles={recommendationStylesPdp}
              {...recommendationAttributes}
              carouselConfigProps={carouselOptions}
              isAbCartCash
              newBag={isNewBag}
              spcBag={spcBag}
              bagItemCount={orderItemsCount}
              isBagPage
            />
          </div>
        </div>
      </>
    );
  };

  renderPlaceRewardRecommendations = () => {
    const { isPlcc, isNewBag, spcBag, orderItemsCount } = this.props;
    const { showPlaceRewardRecommendation } = this.state;

    const recommendationAttributes = {
      variations: 'moduleO',
      page: Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG,
      showLoyaltyPromotionMessage: false,
      headerAlignment: 'center',
      accordionHeader: true,
      showHeightToggle: true,
    };
    const classname = isPlcc ? 'plcc-user' : 'no-plcc-user';
    const carouselOptions = BagPageUtils.PlacecashCarouselOptions.CAROUSEL_OPTIONS;
    const hideContent = showPlaceRewardRecommendation ? '' : 'hide-content';
    let customProductsLength = 4;
    if (getViewportInfo().isDesktop) {
      customProductsLength = 2;
    }

    return (
      <>
        <div className={`cart-placecash placereward ${classname}  ${hideContent}`}>
          <div className="cart-placecash-button">
            {showPlaceRewardRecommendation && <PlaceCashBanner isLeftProgressBar isPlaceReward />}
          </div>
          {showPlaceRewardRecommendation && <hr className="horizontal-line" />}
          <div className="cart-placecash-product">
            <Recommendations
              customProductsLength={customProductsLength}
              headerLabel={getDynamicLabelValues('dynamic.cart.lbl_add_product_toget_placereward')}
              portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.BAG_CART_REWARD_PLCC}
              sequence="0"
              getRecommendationProducts={this.getPlaceRewardRecommendationProductLength}
              starRatingSize={{ small: 63, large: 60 }}
              {...recommendationAttributes}
              carouselConfigProps={carouselOptions}
              inheritedStyles={recommendationStylesPdp}
              isAbCartReward
              newBag={isNewBag}
              spcBag={spcBag}
              bagItemCount={orderItemsCount}
              isBagPage
            />
          </div>
        </div>
      </>
    );
  };

  renderRecommendationsForRecent = () => {
    const { orderItemsCount, isNewBag, spcBag } = this.props;
    const isNoNEmptyBag = orderItemsCount > 0;
    const headerText = isNoNEmptyBag
      ? this.bagPageDynamicLabels.lbl_recently_viewed_full_bag_page
      : this.bagPageDynamicLabels.lbl_recently_viewed_empty_bag_page;
    let carouselOptions;
    if (isNoNEmptyBag) {
      carouselOptions = BagPageUtils.CarouselOptions.CAROUSEL_OPTIONS;
    }
    let customProductsLength = 3;
    if (getViewportInfo()?.isDesktop) {
      customProductsLength = 6;
    }
    return (
      <div className="recentlyViewed">
        <Recommendations
          customProductsLength={customProductsLength}
          page={Constants.RECOMMENDATIONS_PAGES_MAPPING.BAG}
          headerLabel={headerText}
          variations="moduleO"
          portalValue={Constants.RECOMMENDATIONS_MBOXNAMES.RECENTLY_VIEWED}
          inheritedStyles={recommendationStyles}
          carouselConfigProps={carouselOptions}
          starRatingSize={{ small: 68, large: 68 }}
          sequence="2"
          showPeek={{ small: true, medium: false }}
          newBag={isNewBag}
          spcBag={spcBag}
          bagItemCount={orderItemsCount}
          isBagPage
          recommendationCarouselRedesign
        />
      </div>
    );
  };

  getSaveForLaterHeading = () => {
    const { sflItems, isDesktopProductTileCleanUpDisabled } = this.props;
    const sflText = this.bagPageStaticLabels.lbl_sfl_savedLaterButton;

    return (
      <div className="save-for-later-heading-block">
        <BodyCopy
          fontFamily="secondary"
          fontSize={isDesktopProductTileCleanUpDisabled ? 'fs16' : 'fs18'}
          fontWeight={isDesktopProductTileCleanUpDisabled ? 'bold' : 'medium'}
          className="save-for-later-section-heading"
        >
          {`${sflText} (${sflItems?.size})`}
        </BodyCopy>
      </div>
    );
  };

  saveLaterSection = () => {
    const {
      sflItems,
      spcBag,
      isNewBag,
      isLowInventoryBannerEnabled,
      isLowInventoryBannerEnabledForOldDesign,
      priceDropHolidayDateList,
      priceDropPercentageValue,
      isPriceDropNotificationEnabled,
    } = this.props;
    const myBag = 'myBag';
    const sflItemsCount = sflItems.size;
    const sflProducts = sflItems ? JSON.parse(JSON.stringify(sflItems)) : [];
    const sflProductsWithFlag = BagPageUtils.getProductsWithPriceDropFlag(
      sflProducts,
      'sfl',
      priceDropHolidayDateList,
      priceDropPercentageValue
    );
    const sflProductsWithPriceDrop = sflProductsWithFlag.filter((product) => product?.hasPriceDrop);

    return (
      <div className="save-for-later-section">
        {this.getSaveForLaterHeading()}
        <ProductTileWrapper
          pageView={myBag}
          sflItems={sflItems}
          showPlccApplyNow={false}
          isBagPageSflSection
          sflItemsCount={sflItemsCount}
          spcBag={spcBag}
          newBag={isNewBag}
          isLowInventoryBannerEnabled={isLowInventoryBannerEnabled}
          isLowInventoryBannerEnabledForOldDesign={isLowInventoryBannerEnabledForOldDesign}
          sflProductsWithPriceDrop={sflProductsWithPriceDrop}
          isPriceDropNotificationEnabled={isPriceDropNotificationEnabled}
        />
      </div>
    );
  };

  bossUnavailableSection = () => {
    return (
      <div className="test">
        <BossUnavailableGroup {...this.props} />
      </div>
    );
  };

  // eslint-disable-next-line complexity
  saveLaterAndRecommendation = () => {
    const { orderItemsCount } = this.props;
    const isNoNEmptyBag = orderItemsCount > 0;
    const viewPortInfo = getViewportInfo();
    let isMobileDevice = false;
    if (viewPortInfo) {
      const { isMobile } = viewPortInfo;
      isMobileDevice = isMobile;
    }

    return (
      <React.Fragment>
        {this.renderBIA()}
        {this.renderRecommendations()}
        {isMobileDevice && !isNoNEmptyBag && (
          <div className="rounded-container sfl-when-empty-bag-or-guest-user">
            {this.saveLaterSection()}
          </div>
        )}
        {!isMobileDevice && this.wrapSection(this.saveLaterSection('variation_2'), orderItemsCount)}
      </React.Fragment>
    );
  };

  renderCondForPLCCTopBanner = () => {
    const {
      isNewPlccEnabledAbtest,
      isPlcc,
      isGuest,
      isPlccIC,
      orderItemsCount,
      orderItemsCountLocal,
    } = this.props;
    const isNoNEmptyBag = orderItemsCount > 0 || orderItemsCountLocal > 0;
    return (
      !isCanada() && isNoNEmptyBag && isNewPlccEnabledAbtest && (isGuest || !isPlcc) && !isPlccIC
    );
  };

  renderEstimatedTotal = () => {
    const { totalCount, newEstimatedTotalOnBag, totalAmount, isShowBagSimplifiedHeader } =
      this.props;

    return (
      totalCount > 0 &&
      newEstimatedTotalOnBag &&
      !isShowBagSimplifiedHeader && (
        <BodyCopy
          fontFamily="secondary"
          fontSize="fs10"
          className="newEstimatedHeaderText hide-on-desktop hide-on-tablet"
        >
          <div className="newEstimatedHeader">{`${this.bagPageStaticLabels.lbl_orderledger_total} `}</div>
          <div className="priceCurrency">
            <PriceCurrency price={totalAmount} />
          </div>
        </BodyCopy>
      )
    );
  };

  renderSocialProofMessage = () => {
    const {
      isSiteWidePromoBannerAbTestEnabled,
      isExtendedHolidayReturnsBannerAbTestEnabled,
      isHolidayGetItByMessageBannerAbTestEnabled,
      isDeadlinePassed,
      isDefaultSocialProofBanner,
      setDefaultBannerAction,
      timerDeadlineValue,
    } = this.props;
    const richTextHtmlDefault = this.bagPageDynamicLabels.lbl_social_proofing_msg;
    const richTextHtml1 = this.bagPageDynamicLabels.lbl_social_proofing_msg2;
    const richTextHtml2 = this.bagPageDynamicLabels.lbl_social_proofing_msg3;
    const richTextHtml3 = this.bagPageDynamicLabels.lbl_social_proofing_msg4;
    return (
      !isMobileWeb() && (
        <SocialProofBanner
          richTextHtmlDefault={richTextHtmlDefault}
          richTextHtml1={richTextHtml1}
          richTextHtml2={richTextHtml2}
          richTextHtml3={richTextHtml3}
          isSiteWidePromoBannerAbTestEnabled={isSiteWidePromoBannerAbTestEnabled}
          isExtendedHolidayReturnsBannerAbTestEnabled={isExtendedHolidayReturnsBannerAbTestEnabled}
          isHolidayGetItByMessageBannerAbTestEnabled={isHolidayGetItByMessageBannerAbTestEnabled}
          isDefaultSocialProofBanner={isDeadlinePassed || isDefaultSocialProofBanner}
          setDefaultBannerAction={setDefaultBannerAction}
          timerDeadlineValue={timerDeadlineValue}
        />
      )
    );
  };

  renderPriceDropNotificationComponent = () => {
    const {
      cartOrderItems,
      sflItems,
      isNewBag,
      priceDropPercentageValue,
      priceDropHolidayDateList,
    } = this.props;
    const { params } = this.state;
    const { pageView } = params?.[0] || 'myBag';

    const cartProducts = cartOrderItems ? JSON.parse(JSON.stringify(cartOrderItems)) : [];
    const sflProducts = sflItems ? JSON.parse(JSON.stringify(sflItems)) : [];

    const cartProductsWithFlag = BagPageUtils.getProductsWithPriceDropFlag(
      cartProducts,
      'cart',
      priceDropHolidayDateList,
      priceDropPercentageValue
    );
    const sflProductsWithFlag = BagPageUtils.getProductsWithPriceDropFlag(
      sflProducts,
      'sfl',
      priceDropHolidayDateList,
      priceDropPercentageValue
    );

    const cartProductsWithPriceDrop = cartProductsWithFlag.filter(
      (product) => product?.hasPriceDrop
    );
    const sflProductsWithPriceDrop = sflProductsWithFlag.filter((product) => product?.hasPriceDrop);

    const getHeader = () => {
      if (cartProductsWithPriceDrop?.length > 0 && sflProductsWithPriceDrop?.length > 0) {
        return this.bagPageDynamicLabels.lbl_priceDrop_bag_sfl_header;
      }
      if (cartProductsWithPriceDrop?.length > 0) {
        return this.bagPageDynamicLabels.lbl_priceDrop_bag_header;
      }
      if (sflProductsWithPriceDrop?.length > 0) {
        return this.bagPageDynamicLabels.lbl_priceDrop_sfl_header;
      }
      return '';
    };
    const hasPriceDropItems =
      cartProductsWithPriceDrop?.length > 0 || sflProductsWithPriceDrop?.length > 0;
    if (hasPriceDropItems && !this.hasFiredPriceDropAnalytics) {
      this.hasFiredPriceDropAnalytics = true;
      pushEventToAdobeAnalytics('price_drop_shown');
    }
    return (
      hasPriceDropItems && (
        <CollapsableError
          header={getHeader()}
          pageView={pageView}
          isNewBag={isNewBag}
          fromPriceDropNotification
          cartProducts={cartProductsWithPriceDrop}
          sflProducts={sflProductsWithPriceDrop}
        />
      )
    );
  };

  renderLeftSection = () => {
    const {
      sflItems,
      isPlaceCashEnabled,
      isUserLoggedIn,
      isPlaceRewardEnabled,
      cartSflMerged,
      isNewBag,
      isLowInventoryBannerEnabled,
      isLowInventoryBannerEnabledForOldDesign,
      spcBag,
      totalCount,
      orderItemsCount,
      orderItemsCountLocal,
      cartTotalAfterPLCCDiscount,
      orderBalanceTotal,
      openApplyNowModal,
      cartSubTotal,
      bossUnavailableSwitch,
      isSiteWidePromoBannerAbTestEnabled,
      isExtendedHolidayReturnsBannerAbTestEnabled,
      isHolidayGetItByMessageBannerAbTestEnabled,
      isDefaultSocialProofBanner,
      setDefaultBannerAction,
      timerDeadlineValue,
      isDeadlinePassed,
      isShowBagSimplifiedHeader,
      plccOfferPercentage,
      isInternationalShipping,
      isEnableShipmentTilesForInternationalSite,
      isMixedOrder,
      newGlobalErrorMessage,
      isPriceDropNotificationEnabled,
      cartOrderItems,
      priceDropHolidayDateList,
      priceDropPercentageValue,
    } = this.props;

    const myBag = 'myBag';
    const sflItemsCount = sflItems.size;
    const isNoNEmptyBag = orderItemsCount > 0 || orderItemsCountLocal > 0;
    const { headerError, showCondensedHeader } = this.state;
    const { params } = this.state;

    const cartProducts = cartOrderItems ? JSON.parse(JSON.stringify(cartOrderItems)) : [];
    const sflProducts = sflItems ? JSON.parse(JSON.stringify(sflItems)) : [];

    const cartProductsWithFlag = BagPageUtils.getProductsWithPriceDropFlag(
      cartProducts,
      'cart',
      priceDropHolidayDateList,
      priceDropPercentageValue
    );

    const sflProductsWithFlag = BagPageUtils.getProductsWithPriceDropFlag(
      sflProducts,
      'sfl',
      priceDropHolidayDateList,
      priceDropPercentageValue
    );

    const cartProductsWithPriceDrop = cartProductsWithFlag.filter(
      (product) => product?.hasPriceDrop
    );

    const sflProductsWithPriceDrop = sflProductsWithFlag.filter((product) => product?.hasPriceDrop);

    return (
      <React.Fragment>
        {this.renderCondForPLCCTopBanner() && (
          <PLCCTopOfBagView
            cartTotalAfterPLCCDiscount={cartTotalAfterPLCCDiscount}
            orderBalanceTotal={orderBalanceTotal}
            openApplyNowModal={openApplyNowModal}
            cartSubTotal={cartSubTotal}
            plccOfferPercentage={plccOfferPercentage}
          />
        )}
        {isPlaceRewardEnabled &&
          isUserLoggedIn &&
          !isCanada() &&
          this.renderPlaceRewardRecommendations()}
        {isPlaceCashEnabled && this.renderPlaceCashRecommendations()}
        {newGlobalErrorMessage && this.renderHeaderError(headerError, params, showCondensedHeader)}
        {isPriceDropNotificationEnabled && this.renderPriceDropNotificationComponent()}

        {(isNoNEmptyBag || totalCount > 0) && this.renderSocialProofMessage()}
        <div className="bag-section activeSection">
          {this.showMergeCartLimitError()}
          <ProductTileWrapper
            pageView={myBag}
            showPlccApplyNow
            setHeaderErrorState={this.setHeaderErrorState}
            sflItemsCount={sflItemsCount}
            cartSflMerged={cartSflMerged}
            spcBag={spcBag}
            newBag={isNewBag}
            isLowInventoryBannerEnabled={isLowInventoryBannerEnabled}
            isLowInventoryBannerEnabledForOldDesign={isLowInventoryBannerEnabledForOldDesign}
            isSiteWidePromoBannerAbTestEnabled={isSiteWidePromoBannerAbTestEnabled}
            isExtendedHolidayReturnsBannerAbTestEnabled={
              isExtendedHolidayReturnsBannerAbTestEnabled
            }
            isHolidayGetItByMessageBannerAbTestEnabled={isHolidayGetItByMessageBannerAbTestEnabled}
            isDefaultSocialProofBanner={isDeadlinePassed || isDefaultSocialProofBanner}
            setDefaultBannerAction={setDefaultBannerAction}
            timerDeadlineValue={timerDeadlineValue}
            isShowBagSimplifiedHeader={isShowBagSimplifiedHeader}
            isInternationalShipping={isInternationalShipping}
            isEnableShipmentTilesForInternationalSite={isEnableShipmentTilesForInternationalSite}
            isMixedOrder={isMixedOrder}
            cartProductsWithPriceDrop={cartProductsWithPriceDrop}
            sflProductsWithPriceDrop={sflProductsWithPriceDrop}
            isPriceDropNotificationEnabled={isPriceDropNotificationEnabled}
          />
        </div>
        {bossUnavailableSwitch &&
          isNoNEmptyBag &&
          orderItemsCount > 0 &&
          this.bossUnavailableSection()}
        {this.saveLaterAndRecommendation()}
      </React.Fragment>
    );
  };

  renderActions = () => {
    const {
      showAddTobag,
      handleCartCheckout,
      isMobile,
      isBagPage,
      bagLoading,
      isApplePayVisible,
      orderBalanceTotal,
      isNewBag,
      spcBag,
      isStickyCheckoutButtonEnabled,
      isExpressAfterpayEnabled,
      startExpressCheckoutHandler,
      getEstimatedTaxAction,
      calculatedEstimatedTax,
      router,
      totalCount,
      totalAmount,
      isShowBagSimplifiedHeader,
      isInternationalShipping,
      isPayPalDisabled,
    } = this.props;
    const { isScrolling } = this.state;
    return (
      <div ref={this.getBagActionsContainerRef}>
        <AddedToBagActions
          showAddTobag={showAddTobag}
          inheritedStyles={addedToBagActionsStyles}
          handleCartCheckout={handleCartCheckout}
          paypalButtonHeight={isMobile ? 42 : 48}
          containerId="paypal-button-container-bag"
          isBagPage={isBagPage}
          bagLoading={bagLoading}
          isApplePayVisible={isApplePayVisible && orderBalanceTotal > 0}
          showSpcCheckout
          spcBag={spcBag}
          orderBalanceTotal={orderBalanceTotal}
          newBag={isNewBag}
          isScrolling={isScrolling}
          isStickyCheckoutButtonEnabled={isStickyCheckoutButtonEnabled}
          isExpressAfterpayEnabled={isExpressAfterpayEnabled}
          startExpressCheckoutHandler={startExpressCheckoutHandler}
          getEstimatedTaxAction={getEstimatedTaxAction}
          calculatedEstimatedTax={calculatedEstimatedTax}
          router={router}
          getIsUpdateShippingCalled={this.getIsUpdateShippingCalled}
          setIsUpdateShippingCalled={this.setIsUpdateShippingCalled}
          totalCount={totalCount}
          totalAmount={totalAmount}
          isShowBagSimplifiedHeader={isShowBagSimplifiedHeader}
          isInternationalShipping={isInternationalShipping}
          isPayPalDisabled={isPayPalDisabled}
        />
      </div>
    );
  };

  stickyBagCondensedHeader = (headerError, params) => {
    const {
      showAddTobag,
      handleCartCheckout,
      isBagPage,
      bagLoading,
      isApplePayVisible,
      isNewBag,
      spcBag,
      isStickyCheckoutButtonEnabled,
      calculatedEstimatedTax,
      isExpressAfterpayEnabled,
      startExpressCheckoutHandler,
      getEstimatedTaxAction,
      totalAmount,
      router,
      isShowBagSimplifiedHeader,
      newGlobalErrorMessage,
    } = this.props;
    const { orderBalanceTotal, totalCount, orderItemsCount } = this.props;
    const { showCondensedHeader, isScrolling } = this.state;
    const { pageView } = params?.[0] || 'myBag';

    // if (!showCondensedHeader) return null;
    return (
      <div
        ref={this.getBagCondensedHeader}
        className={`${
          orderItemsCount === 0 || orderItemsCount === false || !showCondensedHeader
            ? 'hidden-condensed-header'
            : ''
        }`}
      >
        <Row className="bag-condensed-header">
          <Row className="content-wrapper">
            <Col className="bagHeaderText" colSize={{ large: 8, medium: 4, small: 3 }}>
              <BodyCopy fontFamily="secondary" fontSize="fs16" fontWeight="semibold">
                {`${this.bagPageStaticLabels?.lbl_header_bag} (${totalCount})`}
                <BodyCopy
                  fontFamily="secondary"
                  fontSize="fs13"
                  fontWeight="demiBold"
                  component="span"
                  className="elem-ml-SM"
                >
                  {`${this.bagPageStaticLabels.lbl_orderledger_total}: `}
                  <PriceCurrency price={totalAmount} />
                </BodyCopy>
              </BodyCopy>
            </Col>
            <Col colSize={{ large: 4, medium: 4, small: 3 }}>
              <AddedToBagActions
                showAddTobag={showAddTobag}
                inheritedStyles={addedToBagActionsStyles}
                handleCartCheckout={handleCartCheckout}
                isBagPageStickyHeader
                paypalButtonHeight={42}
                containerId="paypal-button-container-bag-header"
                isBagPage={isBagPage}
                bagLoading={bagLoading}
                showCondensedHeader={showCondensedHeader}
                isApplePayVisible={isApplePayVisible && orderBalanceTotal > 0}
                spcBag={spcBag}
                orderBalanceTotal={orderBalanceTotal}
                newBag={isNewBag}
                isScrolling={isScrolling}
                isStickyCheckoutButtonEnabled={isStickyCheckoutButtonEnabled}
                isExpressAfterpayEnabled={isExpressAfterpayEnabled}
                startExpressCheckoutHandler={startExpressCheckoutHandler}
                getEstimatedTaxAction={getEstimatedTaxAction}
                calculatedEstimatedTax={calculatedEstimatedTax}
                router={router}
                getIsUpdateShippingCalled={this.getIsUpdateShippingCalled}
                setIsUpdateShippingCalled={this.setIsUpdateShippingCalled}
                totalCount={totalCount}
                totalAmount={totalAmount}
                isShowBagSimplifiedHeader={isShowBagSimplifiedHeader}
              />
            </Col>
          </Row>
          <div className="content-wrapper with-condensed-header">
            {newGlobalErrorMessage
              ? this.renderBagpageServerSflErrors(pageView)
              : this.renderHeaderError(headerError, params)}
          </div>
        </Row>
      </div>
    );
  };

  verifyBossUnvailableProducts = ({
    isBossCart,
    isBossEligible,
    isGiftCard,
    preOrderDate,
    isBossEnabled,
    multiPackEnabled,
    availabilitySTH,
    availability,
    accessories,
    isBagPackItem,
  }) => {
    const { params } = this.state;
    const { getBossUnavailableItems, orderItems } = params?.[0] || {};
    const { bossUnavailableSwitch } = this.props;
    const isAllBossUnavailable = orderItems?.size === getBossUnavailableItems?.length;
    if (
      isBossCart &&
      bossUnavailableSwitch &&
      availabilitySTH === CARTPAGE_CONSTANTS.AVAILABILITY.OK &&
      (!accessories || accessories?.size === 0) &&
      !isAllBossUnavailable &&
      !isBagPackItem
    ) {
      return (
        !isBossEligible ||
        !isBossEnabled ||
        isGiftCard ||
        multiPackEnabled ||
        preOrderDate ||
        availability === CARTPAGE_CONSTANTS.AVAILABILITY.UNAVAILABLE
      );
    }
    return false;
  };

  getBossUnavailableProduct = (product) => {
    const { isBossCart, isNonBossCart, isBossEnabled } = this.props;
    const { miscInfo, itemInfo, productInfo } = product || {};
    const { preOrderDate } = itemInfo || {};
    const {
      isBossEligible,
      orderItemType,
      availabilitySTH,
      availability,
      accessories,
      c_accessories: cAccessories,
      c_mainProducts: cMainProducts,
    } = miscInfo || {};
    const isBagPackItem = cAccessories || cMainProducts;
    const { isGiftCard } = productInfo || {};
    const bossUnavailableProduct = this.verifyBossUnvailableProducts({
      isNonBossCart,
      isBossCart,
      isBossEligible,
      isGiftCard,
      preOrderDate,
      isBossEnabled,
      orderItemType,
      availabilitySTH,
      availability,
      accessories,
      isBagPackItem,
    });
    if (bossUnavailableProduct) {
      return product;
    }
    return null;
  };

  renderBagpageServerSflErrors = (pageView) => {
    const {
      bagPageServerError,
      cartItemSflError,
      isModalOpen,
      isPickupModalOpen,
      newGlobalErrorMessage,
      showMaxItemError,
      showOOSError,
      showBackPackDeletedError,
    } = this.props;
    const style = pageView === 'myBag' ? bagTileCSS : customStyles;

    let errorMsg = '';
    if (cartItemSflError) {
      errorMsg = cartItemSflError;
    } else if (
      bagPageServerError &&
      bagPageServerError.errorMessage &&
      !bagPageServerError.isMinibag
    ) {
      errorMsg = bagPageServerError.errorMessage;
    } else if (showMaxItemError || showOOSError || showBackPackDeletedError) {
      if (showMaxItemError) {
        errorMsg = this.bagPageStaticLabels.lbl_coupon_max_quantity_error;
      }
      if (showOOSError) {
        errorMsg = this.bagPageDynamicLabels.lbl_mc_item_oos_error;
      }
      if (showBackPackDeletedError) {
        errorMsg = getDynamicLabelValues('dynamic.cart.lbl_backpack_deleted_error_msg');
      }
    }
    return (
      !isModalOpen &&
      !isPickupModalOpen &&
      (newGlobalErrorMessage && errorMsg ? (
        <GlobalErrorComponentContainer fromCartAndCheckoutPageError errorMsg={errorMsg} />
      ) : (
        <ErrorMessage bagPage customClass={style} error={errorMsg} spc />
      ))
    );
  };

  getHeaderError = ({
    orderItems,
    pageView,
    isUnavailable,
    isSoldOut,
    getUnavailableOOSItems,
    confirmRemoveCartItem,
    isBagPageSflSection,
    isCartItemSFL,
    isCartItemsUpdating,
    isSflItemRemoved,
    isSflItemMovedToBag,
    isBossUnavailable,
    getBossUnavailableItems,
  }) => {
    const {
      cartItemSflError,
      bagPageServerError,
      isModalOpen,
      isPickupModalOpen,
      isNewBag,
      isMiniBagOpen,
      moveItemsToBossUnavailableListAction,
      cartOrderItems,
      bossUnavailableSwitch,
      isBossCart,
      newGlobalErrorMessage,
    } = this.props;
    // Show cartItemSflError on BagPage only when MiniBag is closed
    const showCartItemSflErr = !isMiniBagOpen && cartItemSflError;
    let bossUnavailableProducts = [];
    if (cartOrderItems) {
      const parsedData = JSON.parse(JSON.stringify(cartOrderItems));
      const filteredData = parsedData?.filter((product) => this.getBossUnavailableProduct(product));
      bossUnavailableProducts = filteredData.map((item) => {
        const {
          itemInfo: { itemId, quantity },
          productInfo: { upc },
        } = item || {};
        return {
          productId: upc,
          quantity,
          itemId,
        };
      });
    }

    if (newGlobalErrorMessage) {
      if (!isBagPageSflSection && isSoldOut) {
        return (
          <CollapsableError
            header={getDynamicLabelValues('dynamic.global_d.lbl_errorMessages_inventoryIssue')}
            removeCartItem={confirmRemoveCartItem}
            getUnavailableOOSItems={getUnavailableOOSItems}
            isSoldOut={isSoldOut}
            pageView={pageView}
            isBagPageError
            isNewBag={isNewBag}
            moveItemsToBossUnavailableListAction={moveItemsToBossUnavailableListAction}
            bossUnavailableProducts={bossUnavailableProducts}
          />
        );
      }
      if (!isBagPageSflSection && (isUnavailable || isBossUnavailable)) {
        return (
          <>
            <CollapsableError
              header={getDynamicLabelValues('dynamic.global_d.lbl_errorMessages_inventoryIssue')}
              removeCartItem={confirmRemoveCartItem}
              getUnavailableOOSItems={getUnavailableOOSItems}
              isUnavailable={isUnavailable}
              isBagPageError
              pageView={pageView}
              isNewBag={isNewBag}
              moveItemsToBossUnavailableListAction={moveItemsToBossUnavailableListAction}
              bossUnavailableProducts={bossUnavailableProducts}
              isBossCart={isBossCart}
              bossUnavailableSwitch={bossUnavailableSwitch}
              isBossUnavailable={isBossUnavailable}
              getBossUnavailableItems={getBossUnavailableItems}
              orderItems={orderItems}
            />
          </>
        );
      }
    } else
      return (
        <InformationHeader
          isBagPageError
          orderItems={orderItems}
          pageView={pageView}
          isUnavailable={isUnavailable}
          isSoldOut={isSoldOut}
          getUnavailableOOSItems={getUnavailableOOSItems}
          confirmRemoveCartItem={confirmRemoveCartItem}
          isBagPageSflSection={isBagPageSflSection}
          isCartItemSFL={isCartItemSFL}
          isCartItemsUpdating={isCartItemsUpdating}
          isSflItemRemoved={isSflItemRemoved}
          cartItemSflError={showCartItemSflErr}
          bagPageServerError={!isUnavailable && bagPageServerError}
          isModalOpen={isModalOpen}
          isPickupModalOpen={isPickupModalOpen}
          isSflItemMovedToBag={isSflItemMovedToBag}
          isNewBag={isNewBag}
          moveItemsToBossUnavailableListAction={moveItemsToBossUnavailableListAction}
          bossUnavailableProducts={bossUnavailableProducts}
          bossUnavailableSwitch={bossUnavailableSwitch}
          isBossCart={isBossCart}
          isBossUnavailable={isBossUnavailable}
          getBossUnavailableItems={getBossUnavailableItems}
          newGlobalErrorMessage={newGlobalErrorMessage}
        />
      );
    return null;
  };

  renderHeaderError = (headerError, params, showCondensedHeader) => {
    return headerError && !showCondensedHeader && this.getHeaderError(params[0]);
  };

  getIsShowRightSection = () => {
    const { isMobile, orderItemsCount, orderItemsCountLocal } = this.props;
    const isNoNEmptyBag = orderItemsCount > 0 || orderItemsCountLocal > 0;
    return isMobile ? true : isNoNEmptyBag;
  };

  showMergeCartLimitError = () => {
    const { newGlobalErrorMessage } = this.props;

    if (newGlobalErrorMessage) return null;

    const { showMaxItemError, showOOSError, showBackPackDeletedError } = this.props;

    if (showMaxItemError || showOOSError || showBackPackDeletedError) {
      let cartMergeError = '';
      if (showMaxItemError) {
        cartMergeError = this.bagPageStaticLabels.lbl_coupon_max_quantity_error;
      }
      if (showOOSError) {
        cartMergeError = this.bagPageDynamicLabels.lbl_mc_item_oos_error;
      }
      if (showBackPackDeletedError) {
        cartMergeError = getDynamicLabelValues('dynamic.cart.lbl_backpack_deleted_error_msg');
      }

      return (
        <Notification
          className="max-qty-reached elem-mt-MED"
          status="error"
          scrollIntoView
          isErrorTriangleIcon
          message={cartMergeError}
        />
      );
    }
    return null;
  };

  vmpClickHandler = (e) => {
    e.preventDefault();
    const { getVMPNavigationXHR } = this.props;
    const apiConfigObj = getAPIConfig();
    const { brandSpecificCrossDomain } = apiConfigObj;
    const brandName = 'TCP';
    const bagUrl = '/us/bag';
    const url = `${brandSpecificCrossDomain[brandName] + bagUrl}`;
    getVMPNavigationXHR({ brandName, url });
  };

  showVMPError = () => {
    const { showVMPError } = this.props;
    if (showVMPError) {
      return (
        <Notification
          className="max-qty-reached elem-mt-MED"
          status="error"
          scrollIntoView
          isErrorTriangleIcon
          message=""
        >
          <BagPageVMPView
            errLabel={this.bagPageDynamicLabels.lbl_vmp_error}
            vmpClickHandler={this.vmpClickHandler}
          />
        </Notification>
      );
    }
    return null;
  };

  getShareCart = () => {
    const { saveShareCart, isShareCartEnabled, isMobile, totalCount, trackClickOnCart } =
      this.props;
    const { hasMounted } = this.state;
    if (!isShareCartEnabled || totalCount <= 0 || !(hasMounted && isMobile)) return null;

    return (
      <div className="share-cart-container">
        {BagPageView.shareIcon()}
        <button
          className="share-cart-link show-on-mobile"
          onClick={(e) => {
            e?.preventDefault();
            saveShareCart();
            trackClickOnCart({
              metric33: '1',
              eVar150: 'share cart|bag page',
              customEvents: ['event33'],
            });
            pushEventToAdobeAnalytics('share_cart_click');
          }}
        >
          {this.bagPageStaticLabels?.lbl_bagpage_share_cart}
        </button>
      </div>
    );
  };

  getHeading = () => {
    const { totalCount } = this.props;
    const bagText = this.bagPageStaticLabels?.lbl_header_bag;
    const text = `${bagText} (${totalCount})`;

    return (
      <BodyCopy
        component="h1"
        variant="h6"
        fontSize="fs16"
        fontFamily="secondary"
        fontWeight="bold"
        className="bag-header-new"
      >
        {text}
      </BodyCopy>
    );
  };

  renderError = ({ headerError, newGlobalErrorMessage, pageView, params, showCondensedHeader }) => {
    if (newGlobalErrorMessage) {
      if (isMobileWeb()) {
        return this.renderBagpageServerSflErrors(pageView);
      }
    } else {
      return this.renderHeaderError(headerError, params, showCondensedHeader);
    }

    return null;
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity, complexity
  render() {
    const {
      className,
      totalCount,
      orderItemsCount,
      orderItemsCountLocal,
      isUserLoggedIn,
      isGuest,
      rememberedUser,
      isSignInBannerAbTestEnabled,
      bagLoading,
      isNewBag,
      isLowInventoryBannerEnabled,
      spcBag,
      isStickyCheckoutButtonEnabled,
      getEstimatedTaxAction,
      getIsFromEstimatedTaxForm,
      isTotalCalculated,
      getIsTotalCalculatedAction,
      isSyteEnabled,
      newEstimatedTotalOnBag,
      isNewCouponPositionEnabled,
      totalAmount,
      isCouponSmoothScrollEnabled,
      shareCartError,
      shipments,
      productTotal,
      freeShippingThreshold,
      dynamicShippingCharge,
      isBossEnabled,
      shippingMethodSelected,
      isMixedOrder,
      isFreeShippingProgressBarDisabled,
      isShippingOrder,
      isFreeShippingCouponApplied,
      isShowBagSimplifiedHeader,
      freeShippingPromoType,
      freeShippingMessageForPromosEnabled,
      isMobileWebTileEnhancementEnabled,
      newGlobalErrorMessage,
      onApplyCouponToBagFromList,
      lastAppliedCouponData,
      openCouponDetailModal,
      setOpenCouponDetailModal,
    } = this.props;
    const { sflItems, orderBalanceTotal } = this.props;
    const {
      showStickyHeaderMob,
      loadPaypalStickyHeader,
      headerError,
      showCondensedHeader,
      orderLedgerAfterView,
      hasMounted,
    } = this.state;
    const { params } = this.state;
    const isNoNEmptyBag = orderItemsCount > 0 || orderItemsCountLocal > 0;
    const isNonEmptySFL = sflItems.size > 0;
    const isNotLoaded = orderItemsCount === false;
    const showRightSection = this.getIsShowRightSection();
    const { pageView } = params?.[0] || 'myBag';

    // Syte Script
    const Syte = isSyteEnabled ? SyteVendorScript : () => null;

    return (
      <>
        <div className={className}>
          {loadPaypalStickyHeader && this.stickyBagCondensedHeader(headerError, params)}
          <div
            ref={this.getBagPageHeaderRef}
            className={`${
              showStickyHeaderMob ||
              (newGlobalErrorMessage && pageView === 'myBag' && isMobileWeb())
                ? 'stickyBagHeader'
                : ''
            }`}
          >
            <Row tagName="header" className="cartPageTitleHeader">
              <Col
                colSize={{ small: 2.5, medium: 4, large: 6 }}
                className="left-sec"
                onClick={() => {
                  BagPageUtils.handleChangeActiveSection(BAGPAGE_CONSTANTS.BAG_STATE, this);
                }}
              >
                {this.getHeading()}
                {totalCount > 0 && !newEstimatedTotalOnBag && (
                  <BodyCopy
                    fontFamily="secondary"
                    fontSize="fs10"
                    className={`estimatedHeaderText activeEstimatedHeader`}
                  >
                    {`${this.bagPageStaticLabels.lbl_orderledger_total}: `}
                    <PriceCurrency price={totalAmount} />
                  </BodyCopy>
                )}
              </Col>

              {this.getShareCart()}
            </Row>
            {isShowBagSimplifiedHeader && isNoNEmptyBag && !isUserLoggedIn ? (
              <SimplifiedHeader />
            ) : null}
            {shareCartError ? (
              <ErrorMessage
                fontSize="fs12"
                fontWeight="extrabold"
                error={shareCartError?.errorMessage}
                icon="circle-info-red"
                className="share-cart-error"
                isEspot={shareCartError?.isMaxShareReached}
                isAddedToBag
              />
            ) : null}
            {this.renderError({
              newGlobalErrorMessage,
              pageView,
              params,
              showCondensedHeader,
              headerError,
            })}
          </div>
          <div className={!showCondensedHeader ? 'stickyErrorHeader' : ''}>
            {newGlobalErrorMessage && !isMobileWeb() && this.renderBagpageServerSflErrors(pageView)}
          </div>

          <CnCTemplate
            leftSection={this.renderLeftSection}
            showLeftSection={(isNoNEmptyBag && showRightSection) || isNotLoaded}
            // isNotLoaded={!isNotLoaded}
            orderLedgerAfterView={
              totalCount || orderBalanceTotal > 0 ? this.renderActions() : orderLedgerAfterView
            }
            isUserLoggedIn={isUserLoggedIn}
            isGuest={isGuest}
            showAccordian={false}
            isNonEmptySFL={isNonEmptySFL}
            pageCategory={BAGPAGE_CONSTANTS.BAG_PAGE}
            isSignInBannerAbTestEnabled={isSignInBannerAbTestEnabled}
            isBagPage
            isNoNEmptyBag={isNoNEmptyBag}
            rememberedUser={rememberedUser}
            spcBag={spcBag}
            bagLoading={bagLoading}
            newBag={isNewBag}
            isLowInventoryBannerEnabled={isLowInventoryBannerEnabled}
            isStickyCheckoutButtonEnabled={isStickyCheckoutButtonEnabled}
            getEstimatedTaxAction={getEstimatedTaxAction}
            getIsFromEstimatedTaxForm={getIsFromEstimatedTaxForm}
            getIsTotalCalculatedAction={getIsTotalCalculatedAction}
            isTotalCalculated={isTotalCalculated}
            isNewCouponPositionEnabled={isNewCouponPositionEnabled}
            saveLaterSection={this.saveLaterSection}
            wrapSection={this.wrapSection}
            orderItemsCount={orderItemsCount}
            isCouponSmoothScrollEnabled={isCouponSmoothScrollEnabled}
            renderEstimatedTotal={this.renderEstimatedTotal}
            renderCondForPLCCTopBanner={this.renderCondForPLCCTopBanner}
            shipments={shipments}
            freeShippingThreshold={freeShippingThreshold}
            productTotal={productTotal}
            dynamicShippingCharge={dynamicShippingCharge}
            isBossEnabled={isBossEnabled}
            shippingMethodSelected={shippingMethodSelected}
            isMixedOrder={isMixedOrder}
            isFreeShippingProgressBarDisabled={isFreeShippingProgressBarDisabled}
            isShippingOrder={isShippingOrder}
            isFreeShippingCouponApplied={isFreeShippingCouponApplied}
            freeShippingPromoType={freeShippingPromoType}
            freeShippingMessageForPromosEnabled={freeShippingMessageForPromosEnabled}
            isMobileWebTileEnhancementEnabled={isMobileWebTileEnhancementEnabled}
          />
        </div>
        <CouponDetailModal
          openState={openCouponDetailModal}
          coupon={lastAppliedCouponData}
          onApplyCouponToBagFromList={onApplyCouponToBagFromList}
          onRequestClose={() => {
            setOpenCouponDetailModal(false);
          }}
          additionalClassNameModal="coupon-modal-web"
        />
        {hasMounted && <Syte />}
      </>
    );
  }
}

BagPageView.propTypes = BagPageUtils.BagPagePropTypes;
BagPageView.defaultProps = {
  cartItemSflError: '',
  bagPageServerError: null,
  excludedIds: '',
  isCartBackAbTestEnabled: false,
  isSignInBannerAbTestEnabled: false,
  isDisableBagAnchoring: false,
  isMiniBagOpen: false,
  setBackPackDeletedErrorAction: () => {},
  trackClickOnCart: () => {},
  isOutfitsOnBagEnabled: false,
};
/**
 * Hotfix-Aware Component. The use of `withRefWrapper` and `withHotfix`
 * below are just for making the page hotfix-aware. The "BagPage"
 * argument defines the displayName of the hotfix-aware component.
 */
const BagPageViewWithRefWrapper = withRefWrapper(BagPageView, 'div', 'BagPage');
const BagPageViewWithHotfix = withHotfix(BagPageViewWithRefWrapper);
const BagPageWithRouter = withRouter(BagPageViewWithHotfix);

export default withStyles(BagPageWithRouter, styles);
export { BagPageView as BagPageViewVanilla };
